import React, { useState, useEffect, createContext } from "react";
import { Row, Col } from "react-bootstrap";
import "./App.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import App from './App'
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-checkbox-tree-enhanced/lib/react-checkbox-tree.css";
import styled, { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./themes/GlobalStyles";
import { useTheme } from "./themes/useTheme";
import { useChartTheme } from "./themes/useChartTheme";
import ThemeSelector from "./themes/ThemeSelectorComponent/ThemeSelector";
import dashboard_logo from "./images/dashboard_logo.png";
import Accordion from "react-bootstrap/Accordion";
import ListGroup from "react-bootstrap/ListGroup";
import { Button, Nav, Navbar, NavDropdown, Image } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useAuth } from "./context/AuthProvider";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import themes from "./themes/themes.json";
import helper from "./helper/helper.json"
import chart_themes from "./themes/chart_themes.json";
import { getFromLS, setToLS } from "./utils/storage";
import dashboard_settings from "./dashboard_settings/dashboard_settings.json";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { ThreeCircles } from "react-loader-spinner";
import ReactImageMagnify from 'react-image-magnify';
import ReactSlick from "react-slick";

const ROLE_NAME_MAPPER = {
    "Super Admin": "Super admin",
    "Firm Admin": "Firm admin",
    "Analyzer": "Analyst",
    "Flow Builder": "Flow builder",
    "Data Manager": "Data manager",
    // adding this so that users dont need to referesh their local storage
    "FirmAdmin": "Firm admin",
}

const createCarouselItemImage = (index, options = {}) => (
    <div key={index}>
        <ReactImageMagnify {...{
            smallImage: {
                alt: index,
                isFluidWidth: true,
                src: require(`./pages/vendorimages/${index}.png`)
            },
            largeImage: {
                src: require(`./pages/vendorimages/${index}.png`),
                width: 1200,
                height: 1800
            }
        }} />
        {/* <Image src={require(`./pages/vendorimages/${index}.png`)} /> */}
        <p className="legend">Legend {index}</p>
    </div>
);

export const AppContext = createContext(null);
const Themer = styled.div`
  margin: 0px !important;
`;

const AppWrapper = () => {
    // const [inactive, setInactive] = useState(false);
    const [currPath, setCurrPath] = useState(window.location.pathname);
    const url = (getFromLS("url") != undefined ? getFromLS("url") : [])
    // const baseChildren = <div>{url.map(createCarouselItemImage)}</div>;
    const id = localStorage.getItem("firmId");
    const user = localStorage.getItem("user");
    const firstName = localStorage.getItem("firstname");
    const lastName = localStorage.getItem("lastname");
    const active_features = localStorage.getItem("active-features");
    useEffect(() => {
        setCurrPath(window.location.pathname);
        if (active_features == undefined || active_features.length == 0) {
            setToLS("active-features", []);
        }
        setActiveFeatures(active_features)
    }, []);
    useEffect(() => {
        console.log("App rendering");
    }, []);
    const [localStorageThemes, setLocalStorageThemes] = useState({});
    const localStorageActiveTheme = getFromLS("theme");
    const localStorageActiveChartTheme = getFromLS("chart-theme");
    const enabledMode = getFromLS("mode");
    const [isLoading, setLoading] = useState(false);
    const [darkModeToggle, setDarkModeToggle] = useState(false);
    const [activeFeatures, setActiveFeatures] = useState(getFromLS("active-features"));
    const username = localStorage.getItem("username");
    const restrictedUsers = ["wenddev", "ewilder@wendroffcpa.com", "wendprod"];

    useEffect(() => {
        let mode = getFromLS("mode");
        if (mode == undefined) {
            setToLS("mode", themes.mode["light"]);
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["light"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["light"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["light"].colors.card_body
            );
        } else if (mode.name == "light") {
            setDarkModeToggle(false);
        } else {
            setDarkModeToggle(true);
        }
    }, [darkModeToggle]);
    useEffect(() => {
        if (localStorageActiveTheme == undefined) {
            setToLS("theme", themes.data["light"]);
        }
    }, []);
    useEffect(() => {
        if (!enabledMode || enabledMode == undefined) {
            setToLS("mode", themes.mode["light"]);
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["light"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["light"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["light"].colors.card_body
            );
        } else if (enabledMode.name == "light") {
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["light"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["light"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["light"].colors.card_body
            );
        }
        else {
            setToLS("mode", enabledMode);
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["dark"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["dark"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["dark"].colors.card_body
            );
        }
    }, []);
    useEffect(() => {
        if (localStorageActiveChartTheme == undefined) {
            setToLS("chart-theme", chart_themes.data["Tableau Classic 10"]);
        }
    }, []);

    useEffect(() => {
        const ls_themes = getFromLS("all-themes");
        if (!ls_themes) {
            setLocalStorageThemes();
        } else {
            setLocalStorageThemes(ls_themes);
        }
    }, []);

    useEffect(() => {
        setToLS("chart-themes", chart_themes.data);
        setToLS("all-themes", themes)
    }, []);

    const [allThemes, setAllThemes] = useState(localStorage.getItem("all-themes"));
    const { theme, themeLoaded } = useTheme();
    const [selectedTheme, setSelectedTheme] = useState(theme);

    useEffect(() => {
        setSelectedTheme(theme);
    }, [themeLoaded]);

    const { chartTheme, chartThemeLoaded } = useChartTheme();
    const [selectedChartTheme, setSelectedChartTheme] = useState(chartTheme);

    useEffect(() => {
        setSelectedChartTheme(chartTheme);
    }, [chartThemeLoaded]);

    const [show, setShow] = useState(false);
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate("/login");
        }
    }, []);

    const handleLogout = () => {
        auth.logout();
        localStorage.removeItem("token");
        localStorage.removeItem("firmId");
        localStorage.removeItem("user");
        localStorage.removeItem("username");
        localStorage.removeItem("usertype");
        localStorage.removeItem("firmname");
        localStorage.removeItem("firstname");
        localStorage.removeItem("lastname");
        localStorage.setItem("active-features", []);
        // localStorage.clear()
        navigate("/login");
    };
    const clearCache = () => {
        localStorage.clear();
        window.location.reload();
        // navigate(currPath)
    };
    let handleDarkMode = (e) => {
        setDarkModeToggle(!darkModeToggle);
        if (!darkModeToggle) {
            e.preventDefault();
            setToLS("mode", themes.mode["dark"]);
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["dark"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["dark"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["dark"].colors.card_body
            );
        } else {
            e.preventDefault();
            setToLS("mode", themes.mode["light"]);
            document.documentElement.style.setProperty(
                "--body_color",
                themes.mode["light"].colors.body
            );
            document.documentElement.style.setProperty(
                "--text_color",
                themes.mode["light"].colors.text
            );
            document.documentElement.style.setProperty(
                "--card_body_color",
                themes.mode["light"].colors.card_body
            );
        }
    };

    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} />
                <span className="slider round"></span>
            </label>
        );
    };

    const [modalShow, setModalShow] = React.useState(false);
    const [helperModalShow, setHelperModalShow] = React.useState(false);

    const ThemeComponent = (props) => {
        const [show, setShow] = useState(props.show)
        const setThemeShow = () => {
            setShow(!show)
            setModalShow(!modalShow)
        }
        const hide = props.onHide
        const themeSetter = (prop) => {
            setLoading(true)
            setSelectedTheme(prop)
            setTimeout(() => {
                console.log("IS LOADING: ", isLoading)
                setLoading(false)
            }, 2000);
            console.log("IS LOADING: ", isLoading)
        }
        const chartThemeSetter = (prop) => {
            setLoading(true)
            setSelectedChartTheme(prop)
            setTimeout(() => {
                console.log("IS LOADING: ", isLoading)
                setLoading(false)
            }, 2000);
            console.log("IS LOADING: ", isLoading)
        }
        return (
            <>
                {
                    !isLoading ?
                        <div>
                            <Row style={{ width: "100%", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                {/* <div className="toggler">
                        <span style={{ color: "var(--text_color)", fontWeight: "700" }}>
                            {" "}
                            Dark mode &nbsp; &nbsp;
                        </span>
                        <Switch
                            isToggled={darkModeToggle}
                            onClick={handleDarkMode}
                        ></Switch>
                    </div> */}
                            </Row>
                            <Row className="show-grid">
                                {/* <p className="display-6" style={{ marginLeft: 20 }}>Select or create a theme</p> */}
                                <ThemeSelector
                                    setter={(prop) => themeSetter(prop)}
                                    tether={(prop) => chartThemeSetter(prop)}
                                    isLoading={setLoading}
                                />
                            </Row>
                        </div> :
                        <div className="center-loader">
                            <p>Applying your theme. Please wait a moment.</p>
                            <ThreeCircles
                                height="100"
                                width="100"
                                color="#4fa94d"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="three-circles-rotating"
                                outerCircleColor="var(--theme1_primary)"
                                innerCircleColor="var(--theme1_secondary)"
                                middleCircleColor="var(--theme1_tertiary)"
                            />
                        </div>
                }
            </>
        );
    }

    function HelperModal(props) {
        useEffect(() => {
            url.map((el, index) => {
                console.log("HELPER: ", [el, index])
            })
        }, [])

        // const dataSource = [url.map((index) => ({ srcSet: require(`./pages/vendorimages/${index}.png`), small: require(`./pages/vendorimages/${index}.png`), large: require(`./pages/vendorimages/${index}.png`) }))];

        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                className="helper-grid"
            // centered
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {
                        url != undefined
                            ?
                            //     <Carousel autoFocus={true} showThumbs={true} showStatus={false} showIndicators={true} useKeyboardArrows className="presentation-mode">
                            //        {baseChildren.props.children}
                            //     {/* {
                            //         url.map((el, index)=>{
                            //             <div>
                            //                 <img src={'./pages/vendorimages/' + el + '.png'} alt={url} key={index} className='helper-image' />
                            //             <p className="legend">{el}</p>
                            //         </div>
                            //         })
                            //     } */}
                            // </Carousel>
                            <ReactSlick
                                {...{
                                    dots: true,
                                    infinite: true,
                                    speed: 500,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }}
                            >
                                {url.map((src, index) => (
                                    <div key={index}>
                                        <ReactImageMagnify
                                            {...{
                                                smallImage: {
                                                    alt: 'Wristwatch by Versace',
                                                    isFluidWidth: true,
                                                    src: require(`./pages/vendorimages/${src}.png`),
                                                    // srcSet: src.srcSet,
                                                    sizes: '(max-width: 480px) 100vw, (max-width: 1200px) 30vw, 360px'
                                                },
                                                largeImage: {
                                                    src: require(`./pages/vendorimages/${src}.png`),
                                                    width: 1426,
                                                    height: 2000
                                                },
                                                lensStyle: { backgroundColor: 'rgba(0,0,0,.6)' }
                                            }}
                                        />
                                    </div>
                                ))}
                            </ReactSlick>

                            // <Image src={require('./pages/vendorimages/' + url + '.png')} alt={url} className='helper-image' />
                            :
                            <p>
                                No documentation.
                            </p>
                    }
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
        );
    }

    function openNav() {
        document.getElementById("myNav").style.height = "100%";
    }

    function closeNav() {
        document.getElementById("myNav").style.height = "0%";
    }

    return (
        <>
            {themeLoaded && (
                <ThemeProvider theme={selectedTheme} chartTheme={selectedChartTheme}>
                    <GlobalStyles />
                    <Themer>
                        {/* <ThemeComponent
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                        /> */}
                        <HelperModal
                            show={helperModalShow}
                            onHide={() => setHelperModalShow(false)}
                        />
                        {id && user ?
                            <div>
                                <div id="myNav" class="nav-overlay" style={{ zIndex: 2000 }}>
                                    <a class="closebtn" onClick={() => closeNav()}>&times;</a>
                                    <div class="nav-overlay-content">
                                        {active_features.includes("THMS") &&
                                            <Accordion style={{ border: 0, borderColor: "#fff", padding: 0 }} defaultActiveKey={null}>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header style={{borderRadius: 12}}>
                                                        <Icon.PaletteFill className={"accordian-icons"} />{" "}
                                                        &nbsp;&nbsp; Theme Settings
                                                    </Accordion.Header>
                                                    <Accordion.Body style={{ minHeight: 500, maxHeight: 575, overflowY: "auto" }}>
                                                        <ThemeComponent />
                                                    </Accordion.Body>
                                                </ Accordion.Item>
                                            </Accordion>
                                        }
                                        {(active_features.includes("FRMADMN") && localStorage.getItem("usertype") === "Firm Admin") &&
                                            <Accordion.Header onClick={() => {
                                                closeNav()
                                                navigate("/firmadmin")
                                            }
                                            }>
                                                <Icon.PersonFillGear className={"accordian-icons"} />{" "}
                                                &nbsp;&nbsp; Firm admin panel
                                            </Accordion.Header>
                                        }
                                        {/* {localStorage.getItem("usertype")==="Super Admin" &&
                                            <div className="themes-button">
                                                <Accordion.Header onClick={() => navigate("/superadmin")}>
                                                    <Icon.PersonFillGear className={"accordian-icons"} />{" "}
                                                    &nbsp;&nbsp; Super admin panel
                                                </Accordion.Header>
                                            </div>} */}
                                        <div className="cache">
                                            <Accordion.Header>
                                                <Button
                                                    variant="secondary"
                                                    onClick={handleLogout}
                                                    style={{
                                                        width: "50%",
                                                        borderRadius: "0px",
                                                    }}
                                                >
                                                    <Icon.DoorClosedFill
                                                        className={"accordian-icons"}
                                                    />{" "}
                                                    Logout
                                                </Button>
                                                <OverlayTrigger
                                                    delay={{ hide: 450, show: 300 }}
                                                    overlay={(props) => (
                                                        <Tooltip {...props}>
                                                            Clear cache and hard reload
                                                        </Tooltip>
                                                    )}
                                                    placement="bottom"
                                                >
                                                    <Button
                                                        variant="secondary"
                                                        onClick={clearCache}
                                                        className="cacheone"
                                                        style={{
                                                            width: "50%",
                                                            borderRadius: "0px",
                                                            margin: 0,
                                                        }}
                                                    >
                                                        <Icon.ArrowCounterclockwise
                                                            className={"accordian-icons"}
                                                        />{" "}
                                                        Clear cache
                                                    </Button>
                                                </OverlayTrigger>
                                            </Accordion.Header>
                                        </div>
                                    </div>
                                </div>
                                {/* <span
                                    style={{ fontSize: "30px", cursor: "pointer" }}
                                    onClick={() => openNav()}>
                                    &#9776; open
                                </span> */}
                                <div style={{ position: "relative", cursor: "pointer" }}>
                                    <div className="new-nav flex-row-center-center" onClick={() => openNav()}>
                                        <div className="profile-icon">
                                            <Icon.PersonCircle className="firm-logo" />
                                        </div>
                                        <div className="user-role-name profile-full-section">
                                            {firstName + " " + lastName}&nbsp;
                                            <br/>
                                            <div style={{ fontSize: "10px" }}>
                                                {localStorage.getItem("usertype").toUpperCase()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            // <Navbar collapseOnSelect expand="lg" className="sticky-nav">
                            //     <Navbar.Brand className="dashboard-logo" onClick={() => localStorage.getItem("usertype") == "SuperAdmin" ? "" : navigate("/dashboard")}>
                            //         <img
                            //             src={dashboard_logo}
                            //             alt="logo"
                            //         />
                            //     </Navbar.Brand>
                            //     <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                            //     <Navbar.Collapse id="responsive-navbar-nav">
                            //         <Nav className="me-auto"></Nav>

                            //         <div className="nav-right">
                            //             <Nav className="helper">
                            //                 <Nav.Link href="" className={"helper"}>
                            //                     {" "}
                            //                     <Icon.QuestionCircle
                            //                         onClick={() => setHelperModalShow(true)}
                            //                     />{" "}
                            //                     &nbsp;
                            //                 </Nav.Link>
                            //             </Nav>
                            //             <NavDropdown
                            //                 title={
                            //                     <span className={"settingTitle"}>
                            //                         <Icon.PersonFill className="firm-logo" />&nbsp;&nbsp; | &nbsp;&nbsp;{user.toUpperCase()}
                            //                         <p className="user-role-name">{ROLE_NAME_MAPPER[localStorage.getItem("usertype")]}</p>
                            //                     </span>
                            //                 }
                            //                 id="navbarScrollingDropdown"
                            //                 autoClose={true}
                            //                 className="settingDropdown"
                            //                 align={{ lg: 'end' }}
                            //             >
                            //                 {active_features.includes("THMS") &&
                            //                     <div className="themes-button">
                            //                         <Accordion.Header onClick={() => setModalShow(true)}>
                            //                             <Icon.PaletteFill className={"accordian-icons"} />{" "}
                            //                             &nbsp;&nbsp; Theme Settings
                            //                         </Accordion.Header>
                            //                     </div>}
                            //                 {(active_features.includes("FRMADMN") && localStorage.getItem("usertype")==="Firm Admin" ) &&
                            //                     <div className="themes-button">
                            //                         <Accordion.Header onClick={() => navigate("/firmadmin")}>
                            //                             <Icon.PersonFillGear className={"accordian-icons"} />{" "}
                            //                             &nbsp;&nbsp; Firm admin panel
                            //                         </Accordion.Header>
                            //                     </div>}
                            //                 {/* {localStorage.getItem("usertype")==="SuperAdmin" &&
                            //                 <div className="themes-button">
                            //                     <Accordion.Header onClick={() => navigate("/superadmin")}>
                            //                         <Icon.PersonFillGear className={"accordian-icons"} />{" "}
                            //                         &nbsp;&nbsp; Super admin panel
                            //                     </Accordion.Header>
                            //                 </div>} */}
                            //                 <div className="cache">
                            //                     <Accordion.Header>
                            //                         <Button
                            //                             variant="secondary"
                            //                             onClick={handleLogout}
                            //                             style={{
                            //                                 width: "50%",
                            //                                 borderRadius: "0px",
                            //                             }}
                            //                         >
                            //                             <Icon.DoorClosedFill
                            //                                 className={"accordian-icons"}
                            //                             />{" "}
                            //                             Logout
                            //                         </Button>
                            //                         <OverlayTrigger
                            //                             delay={{ hide: 450, show: 300 }}
                            //                             overlay={(props) => (
                            //                                 <Tooltip {...props}>
                            //                                     Clear cache and hard reload
                            //                                 </Tooltip>
                            //                             )}
                            //                             placement="bottom"
                            //                         >
                            //                             <Button
                            //                                 variant="secondary"
                            //                                 onClick={clearCache}
                            //                                 className="cacheone"
                            //                                 style={{
                            //                                     width: "50%",
                            //                                     borderRadius: "0px",
                            //                                     margin: 0,
                            //                                 }}
                            //                             >
                            //                                 <Icon.ArrowCounterclockwise
                            //                                     className={"accordian-icons"}
                            //                                 />{" "}
                            //                                 Clear cache
                            //                             </Button>
                            //                         </OverlayTrigger>
                            //                     </Accordion.Header>
                            //                 </div>
                            //             </NavDropdown>

                            //         </div>
                            //     </Navbar.Collapse>
                            // </Navbar>
                            :
                            <></>
                        }
                        <App
                            activeFeatures={active_features}
                        />
                    </Themer>
                </ThemeProvider>
            )}</>
    )
}

export default AppWrapper;